import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { NavigationStatus } from "../../../../navigation/components/navigation-bar/nav-data";
import { StateManagementService } from "../../../../providers/state-management/state-management.service";
/**
 * Generated class for the PatientHistoryCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "patient-history-card",
  templateUrl: "patient-history-card.html",
})
export class PatientHistoryCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Input() patientId;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  declinable: boolean;
  endDate: string;
  navigationStatus: NavigationStatus;
  constructor(private stateData: StateManagementService) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label = this.config.label;
    this.access = this.config.access;
    this.declinable = this.config.declinable;
    let navigationData = this.stateData.navigationStatus();
    if (navigationData) {
      this.navigationStatus = navigationData;
      let dateTime = this.navigationStatus.completedDte;
      if (dateTime) {
        this.endDate =
          moment(dateTime, "YYYYMMDDThhmmss.SSS").format(
            "YYYY-MM-DDTHH:mm:ss"
          ) + "Z";
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/patient-history-card/patient-history-card.ts